import { create } from 'zustand';

export const useSidebarCollapse = create(set => ({
  isCollapsed: false,
  setIsCollapsed: value => set({ isCollapsed: value }),
}));
